import { POST } from '../_http';
import type { operations } from '@/types/schemas/calcs.main';
type controller = operations['MaxLoanAmountController_calculate'];

export type MaxLoanAmountBody = controller['requestBody']['content']['application/json'];
export type MaxLoanAmountResponse = controller['responses']['200']['content']['application/json'];

export const maxLoanAmount = POST('/formulas/max-loan-amount')<MaxLoanAmountBody, MaxLoanAmountResponse>;
